module.exports = __webpack_public_path__ + "img/sample_bg_03.412a77b3.jpg";